import React from "react";
import { logger } from "@bn-monorepo/js-packages";

interface Props {
  errorMesage: string;
  children?: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: any, errorInfo: any) {
    logger.logError(`${errorInfo} error=${JSON.stringify(error)}`);
  }

  render() {
    const { errorMesage } = this.props;
    if (this.state.hasError) {
      return <header style={{ padding: 10, fontSize: 20 }}>{errorMesage}</header>;
    }

    return this.props.children || null;
  }
}

export default ErrorBoundary;
